






























import { Component } from 'vue-property-decorator';
import SaascadaVueDialog from '@/components/Shared/SaascadaVueDialog';
import { ProductDetailsModule } from '@/store/Products/ProductDetailsModule';

@Component({ name: 'TransactionalFeesDeleteDialog' })
export default class extends SaascadaVueDialog {

    get feeName() {
        return ProductDetailsModule.currentTransactionalFee.name;
    }

    async deleteFee() {
        await ProductDetailsModule.deleteTransactionalFee();
        this.dialog = false;
    }

}
